export default __webpack_public_path__ + "static/media/down.671baab0.svg";